import { type ReactNode, forwardRef, useCallback } from 'react';

import type { TpModalProps } from '@mentalgrowth/ui-kit-web';
import ModalContainer from '../modal-container/modal-container';

import styles from './modal.module.scss';

export type TpComponentModalProps = TpModalProps & {
  showCloseButton?: boolean;
  title?: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  handleCloseModal?: () => void | null;
  showMobileHeader?: boolean;
};

const Modal = forwardRef<HTMLDivElement, TpComponentModalProps>(
  (props: TpComponentModalProps, ref) => {
    const {
      onHide,
      showCloseButton = true,
      title,
      description,
      footer,
      children,
      handleCloseModal,
      ...otherProps
    } = props;

    const handleClose = useCallback(() => {
      handleCloseModal && handleCloseModal();
      onHide && onHide();
    }, [handleCloseModal, onHide]);

    return (
      <ModalContainer
        canClose={showCloseButton}
        closeButtonAlign="right"
        onHide={handleClose}
        ref={ref}
        {...otherProps}
      >
        {title && <h2 className={styles.title}>{title}</h2>}
        {description && <p className={styles.description}>{description}</p>}
        {children}
        {footer && <div className={styles.footerContainer}>{footer}</div>}
      </ModalContainer>
    );
  },
);

export default Modal;
